import React from "react";
import DeblurIcon from "@mui/icons-material/Deblur";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import HomeIcon from "@mui/icons-material/Home";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import { Icon } from "../../Icon";
export const orderedMenuItems = {
    home: [
        {
            serviceIds: ["homescreen"],
            label: "home",
            icon: React.createElement(HomeIcon, null),
        },
    ],
    services: [
        {
            serviceIds: ["cfc"],
            label: "fpc",
            icon: React.createElement(DeblurIcon, null),
        },
        {
            serviceIds: ["reduction-homepage-frontend"],
            label: "reduction",
            icon: React.createElement(TrendingDownIcon, null),
        },
        {
            serviceIds: ["fpm"],
            label: "fpm",
            icon: React.createElement(Icon, { name: "offsetting" }),
        },
        {
            serviceIds: ["transparency-dashboard-frontend"],
            label: "transparency",
            icon: React.createElement(Icon, { name: "transparency" }),
        },
    ],
    additionalServices: [
        {
            serviceIds: ["network-supplier", "network-purchaser", "network"],
            label: "network",
            icon: React.createElement(Icon, { name: "supplyNetwork" }),
        },
        {
            serviceIds: ["analytics.basic"],
            label: "analytics",
            icon: React.createElement(Icon, { name: "analytics" }),
        },
        {
            serviceIds: ["transparency.reports"],
            label: "transparencyReports",
            icon: React.createElement(FactCheckIcon, null),
        },
        {
            serviceIds: ["transparency-dashboard-frontend"],
            label: "cpCertified",
            icon: React.createElement(Icon, { name: "cpCertified" }),
        },
    ],
};
//# sourceMappingURL=constants.js.map